<template>
	<van-tabs v-model="innerValue" v-bind="$attrs" v-on="$listeners">
		<van-tab v-for="(tab, index) in option" :key="index" :title="tab"></van-tab>
	</van-tabs>
</template>

<script>
import { Tab, Tabs } from 'vant';

export default {
	components: {
		'van-tab': Tab,
		'van-tabs': Tabs
	},
	props: {
		value: {
			type: [String, Number]
		},
		option: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {};
	},
	computed: {
		innerValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			}
		}
	}
};
</script>

<style lang="less">
.van-tabs--line {
	position: relative;
	z-index: 3;

	&::after {
		top: 0;
		left: 0;
		content: '';
		width: 200%;
		height: 200%;
		position: absolute;
		border-bottom: 1px solid #e8eaef;
		transform-origin: 0 0;
		transform: scale(0.5, 0.5);
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		pointer-events: none;
	}
}
.van-tabs--line .van-tabs__wrap {
	height: 0.4rem;
}
.van-tab {
	color: #333;
	text-align: center;

	/* 15/H5-regular */
	font-family: 'PingFang SC';
	font-size: 0.15rem;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 21px */
}
.van-tab--active {
	color: var(--ir-theme-color);
	font-weight: 500;
}
.van-tabs__line {
	background-color: var(--ir-theme-color);
	border-radius: 0;
	width: 0.4rem;
	height: 0.02rem;
}
</style>
